import { Component } from '@angular/core';

@Component({
  selector: 'ct-extraction-table-extraction-tool-hints',
  templateUrl: './table-extraction-tool-hints.component.html',
})
export class TableExtractionToolHintsComponent {}
